import { useState, useCallback } from 'react';

import { announcements, getLatestAnnouncement, type Announcement } from '@/new/lib/announcements';

const STORAGE_KEY = 'wexler-dismissed-announcements';

function getDismissedIds(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveDismissedIds(ids: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // silent fail
  }
}

export function useAnnouncement(): {
  announcement: Announcement | null;
  dismiss: () => void;
} {
  const [dismissedIds, setDismissedIds] = useState<string[]>(getDismissedIds);

  const announcement = getLatestAnnouncement(dismissedIds);

  const dismiss = useCallback(() => {
    if (!announcement) return;
    const updated = [...new Set([...dismissedIds, ...announcements.map(({ id }) => id)])];
    setDismissedIds(updated);
    saveDismissedIds(updated);
  }, [announcement, dismissedIds]);

  return { announcement, dismiss };
}
